import { useMemo } from "react";
import experienceEn from "../experience.json";
import experienceEs from "../data/experience.es.json";
import { useLocale } from "../i18n/LocaleContext";

export function useExperience() {
  const { locale } = useLocale();
  return useMemo(() => (locale === "es" ? experienceEs : experienceEn), [locale]);
}
